export const SET_EDITED_BATTLE_PAGEID = "SET_EDITED_BATTLE_PAGEID";
export const SET_BATTLE_QUESTIONS = "SET_BATTLE_QUESTIONS";
export const SET_BATTLE_LOADING = "SET_BATTLE_LOADING";
export const SET_BATTLE_MASTER_FLAG = "SET_BATTLE_MASTER_FLAG";
